import { useNavigateBack } from '@exam-management/common/hooks';
import { type Link as BaseLink } from '@exam-management/router';
import { ArrowBackRoundedIcon, Button, type ButtonProps } from '@shared/components';
import { type ComponentProps } from 'react';

type BaseLinkProps = ComponentProps<typeof BaseLink>;

export interface NavigateBackLinkWithHistoryProps {
  fallbackPath: BaseLinkProps['to'];
  matchPatterns?: string | string[];
  label?: string;
  sx?: ButtonProps['sx'];
  fallbackParams?: BaseLinkProps['params'];
  replace?: BaseLinkProps['replace'];
}

export default function NavigateBackLinkWithHistory(
  props: Readonly<NavigateBackLinkWithHistoryProps>,
) {
  const {
    fallbackPath,
    matchPatterns,
    label = 'Back',
    sx,
    fallbackParams,
    replace = false,
  } = props;

  const { handleBack } = useNavigateBack({
    fallbackPath,
    matchPatterns,
    fallbackParams,
    replace,
  });

  return (
    <Button
      variant='text'
      startIcon={<ArrowBackRoundedIcon />}
      onClick={handleBack}
      sx={{
        p: (theme) => theme.spacing(0),
        minWidth: 'auto',
        height: 'auto',
        color: (theme) => theme.palette.text.secondary,
        ...sx,
      }}
    >
      {label}
    </Button>
  );
}
